<template>
  <div id="wrapper">
    <Nav :message="message" />
    <ClientList />
  </div>
</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import ClientList from '@/components/crm/ClientList.vue'

export default {
  name: 'client',
  props: ['message'],
  components: {
    Nav,
    ClientList
  }
}
</script>